export enum BindableObjectType {
    undefined = 'undefined',
    folder = 'folder',
    boolean = 'boolean',
    number = 'number',
    string = 'string',
    date = 'date',
    color = 'color',
    object = 'object',
}